var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentTemplateId)?_c(_vm.config.componentMappings[_vm.componentTemplateId],_vm._b({tag:"Component",staticClass:"clearfix"},'Component',_vm.componentProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }